<template>
  <loading v-if="loading"></loading>
  <div class="p-dashboard" v-else>
    <page-title
      >Global Dashboard Management
      <dashboard-controls
        @save-layout="saveLayout"
        @toggle-customize="toggleCustomize"
        :edit-mode="editMode"
    /></page-title>

    <section class="dropzone dropzone--header">
      <p class="dropzone__label">Header</p>
      <div class="dropzone__container">
        <draggable
          class="dashboard--dynamic__row"
          @start="dragging = true"
          @end="dragging = false"
          :disabled="!editMode"
          handle=".handle"
          group="rows"
          v-model="headerLayout"
          v-bind="dragOptions"
        >
          <transition-group
            type="transition"
            :name="!dragging ? 'flip-list' : null"
          >
            <div v-for="(row, index) in headerLayout" :key="index">
              <div v-if="editMode" slot="header">
                <span class="handle cursor-pointer"
                  ><icon width="16" height="16" icon="move" /> Move row</span
                >
                <base-button
                  ghost
                  inline
                  icon-before="element-group"
                  @click="toggleColumnWidth(index, 'headerLayout')"
                  >Change row layout</base-button
                >
                <base-button
                  @click="deleteRow(index, 'headerLayout')"
                  ghost
                  inline
                  icon-before="delete"
                  >Delete row</base-button
                >
              </div>

              <draggable
                @start="dragging = true"
                @end="dragging = false"
                :disabled="!editMode"
                v-if="row.length"
                :group="`els${index}`"
                handle=".handle-el"
                v-model="headerLayout[index]"
                v-bind="dragOptions"
              >
                <transition-group
                  type="transition"
                  :name="!dragging ? 'flip-list' : null"
                  class="row mb-12"

                >
                  <div
                    v-for="(dashEl, elEindex) in row"
                    :key="elEindex"
                    :class="`col-xs-12 col-md-${dashEl.cssClass} relative`"
                  >
                    <div
                      v-if="editMode && dashEl.type"
                      class="dashboard__overlay"
                    >

                      <div class="dashboard__overlay__controls">

                        <base-button
                          outline
                          success-invert
                          icon-before="move-side"
                          class="handle-el"
                          v-if="notSingleCol(index, 'headerLayout')"
                          >Move</base-button
                        >
                        <base-button
                          primary-invert
                          icon-before="cog"
                          @click="
                            togglePreference(index, elEindex, 'headerLayout')
                          "
                          >Configure</base-button
                        >

                        <base-button
                          @click="
                            deleteElement(index, elEindex, 'headerLayout')
                          "
                          outline
                          danger-invert
                          icon-before="delete"
                          >Delete</base-button
                        >
                      </div>
                    </div>
                    <component
                      :is="dashEl.type"
                      v-if="dashEl.type"
                      v-bind="dashEl.props"
                      :css-class="dashEl.cssClass"
                    />
                    <div
                      v-else-if="!dashEl.type && editMode"
                      :class="[
                        { 'dashboard--add-el': !dashEl.type && editMode },
                      ]"
                    >
                      <base-button
                        @click="
                          toggleAddWidget(index, elEindex, 'headerLayout')
                        "
                        :primary="true"
                      >
                        Add widget
                      </base-button>
                    </div>
                  </div>
                </transition-group>
              </draggable>
              <draggable
                class="row mb-12"
                @start="dragging = true"
                @end="dragging = false"
                :disabled="!editMode"
                v-else
              >
                <div class="col-xs-12 dashboard--add-el">
                  <base-button
                    @click="toggleAddWidget(index, 0, 'headerLayout')"
                    :primary="true"
                    >Add widget</base-button
                  >
                </div>
              </draggable>
            </div>
          </transition-group>
        </draggable>
        <div class="row mb-12 dashboard--add-el" v-if="editMode">
          <base-button :primary="true" @click="addRow('headerLayout')"
            >Add new row</base-button
          >
        </div>
      </div>
    </section>

    <section class="dropzone dropzone--main">
      <p class="dropzone__label">Main / User</p>
      <div class="dropzone__container">
        <draggable
          class="dashboard--dynamic__row"
          @start="dragging = true"
          @end="dragging = false"
          :disabled="!editMode"
          handle=".handle"
          group="rows"
          v-model="mainLayout"
          v-bind="dragOptions"
        >
          <transition-group
            type="transition"
            :name="!dragging ? 'flip-list' : null"
          >
            <div v-for="(row, index) in mainLayout" :key="index">
              <div v-if="editMode" slot="header">
                <span class="handle cursor-pointer"
                  ><icon width="16" height="16" icon="move" /> Move row</span
                >
                <base-button
                  ghost
                  inline
                  icon-before="element-group"
                  @click="toggleColumnWidth(index, 'mainLayout')"
                  >Change row layout</base-button
                >
                <base-button
                  @click="deleteRow(index, 'mainLayout')"
                  ghost
                  inline
                  icon-before="delete"
                  >Delete row</base-button
                >
              </div>

              <draggable
                @start="dragging = true"
                @end="dragging = false"
                :disabled="!editMode"
                v-if="row.length"
                :group="`els${index}`"
                handle=".handle-el"
                v-model="mainLayout[index]"
                v-bind="dragOptions"
              >
                <transition-group
                  type="transition"
                  :name="!dragging ? 'flip-list' : null"
                  class="row mb-12"
                >
                  <div
                    v-for="(dashEl, elEindex) in row"
                    :key="elEindex"
                    :class="`col-xs-12 col-md-${dashEl.cssClass} relative`"
                  >
                    <div
                      v-if="editMode && dashEl.type"
                      class="dashboard__overlay"
                    >
                      <div class="dashboard__overlay__controls">
                        <base-button
                          outline
                          success-invert
                          icon-before="move-side"
                          class="handle-el"
                          v-if="notSingleCol(index, 'mainLayout')"
                          >Move</base-button
                        >
                        <base-button
                          primary-invert
                          icon-before="cog"
                          @click="
                            togglePreference(index, elEindex, 'mainLayout')
                          "
                          >Configure</base-button
                        >

                        <base-button
                          @click="deleteElement(index, elEindex, 'mainLayout')"
                          outline
                          danger-invert
                          icon-before="delete"
                          >Delete</base-button
                        >
                      </div>
                    </div>
                    <component
                      :is="dashEl.type"
                      v-if="dashEl.type"
                      v-bind="dashEl.props"
                      :css-class="dashEl.cssClass"
                    />
                    <div
                      v-else-if="!dashEl.type && editMode"
                      :class="[
                        { 'dashboard--add-el': !dashEl.type && editMode },
                      ]"
                    >
                      <base-button
                        @click="toggleAddWidget(index, elEindex, 'mainLayout')"
                        :primary="true"
                      >
                        Add widget
                      </base-button>
                    </div>
                  </div>
                </transition-group>
              </draggable>
              <draggable
                class="row mb-12"
                @start="dragging = true"
                @end="dragging = false"
                :disabled="!editMode"
                v-else
              >
                <div class="col-xs-12 dashboard--add-el">
                  <base-button
                    @click="toggleAddWidget(index, 0, 'mainLayout')"
                    :primary="true"
                    >Add widget</base-button
                  >
                </div>
              </draggable>
            </div>
          </transition-group>
        </draggable>
        <div class="row mb-12 dashboard--add-el" v-if="editMode">
          <base-button :primary="true" @click="addRow('mainLayout')"
            >Add new row</base-button
          >
        </div>
      </div>
    </section>

    <section class="dropzone dropzone--footer">
      <p class="dropzone__label">Footer</p>
      <div class="dropzone__container">
        <draggable
          class="dashboard--dynamic__row"
          @start="dragging = true"
          @end="dragging = false"
          :disabled="!editMode"
          handle=".handle"
          group="rows"
          v-model="footerLayout"
          v-bind="dragOptions"
        >
          <transition-group
            type="transition"
            :name="!dragging ? 'flip-list' : null"
          >
            <div v-for="(row, index) in footerLayout" :key="index">
              <div v-if="editMode" slot="header">
                <span class="handle cursor-pointer"
                  ><icon width="16" height="16" icon="move" /> Move row</span
                >
                <base-button
                  ghost
                  inline
                  icon-before="element-group"
                  @click="toggleColumnWidth(index, 'footerLayout')"
                  >Change row layout</base-button
                >
                <base-button
                  @click="deleteRow(index, 'footerLayout')"
                  ghost
                  inline
                  icon-before="delete"
                  >Delete row</base-button
                >
              </div>

              <draggable
                @start="dragging = true"
                @end="dragging = false"
                :disabled="!editMode"
                v-if="row.length"
                :group="`els${index}`"
                handle=".handle-el"
                v-model="footerLayout[index]"
                v-bind="dragOptions"
              >
                <transition-group
                  type="transition"
                  :name="!dragging ? 'flip-list' : null"
                  class="row mb-12"
                >
                  <div
                    v-for="(dashEl, elEindex) in row"
                    :key="elEindex"
                    :class="`col-xs-12 col-md-${dashEl.cssClass} relative`"
                  >
                    <div
                      v-if="editMode && dashEl.type"
                      class="dashboard__overlay"
                    >
                      <div class="dashboard__overlay__controls">
                        <base-button
                          outline
                          success-invert
                          icon-before="move-side"
                          class="handle-el"
                          v-if="notSingleCol(index, 'footerLayout')"
                          >Move</base-button
                        >
                        <base-button
                          primary-invert
                          icon-before="cog"
                          @click="
                            togglePreference(index, elEindex, 'footerLayout')
                          "
                          >Configure</base-button
                        >

                        <base-button
                          @click="
                            deleteElement(index, elEindex, 'footerLayout')
                          "
                          outline
                          danger-invert
                          icon-before="delete"
                          >Delete</base-button
                        >
                      </div>
                    </div>
                    <component
                      :is="dashEl.type"
                      v-if="dashEl.type"
                      v-bind="dashEl.props"
                      :css-class="dashEl.cssClass"
                    />
                    <div
                      v-else-if="!dashEl.type && editMode"
                      :class="[
                        { 'dashboard--add-el': !dashEl.type && editMode },
                      ]"
                    >
                      <base-button
                        @click="
                          toggleAddWidget(index, elEindex, 'footerLayout')
                        "
                        :primary="true"
                      >
                        Add widget
                      </base-button>
                    </div>
                  </div>
                </transition-group>
              </draggable>
              <draggable
                class="row mb-12"
                @start="dragging = true"
                @end="dragging = false"
                :disabled="!editMode"
                v-else
              >
                <div class="col-xs-12 dashboard--add-el">
                  <base-button
                    @click="toggleAddWidget(index, 0, 'footerLayout')"
                    :primary="true"
                    >Add widget</base-button
                  >
                </div>
              </draggable>
            </div>
          </transition-group>
        </draggable>
        <div class="row mb-12 dashboard--add-el" v-if="editMode">
          <base-button :primary="true" @click="addRow('footerLayout')"
            >Add new row</base-button
          >
        </div>
      </div>
    </section>

    <dashboard-controls
      @save-layout="saveLayout"
      @toggle-customize="toggleCustomize"
      :edit-mode="editMode"
    />

    <modal v-if="showColumnWidthModal">
      <template slot="header">
        <h3>Set column width</h3>
      </template>
      <p>Select how many columns you want to display</p>
      <div class="flex space-even">
        <button
          v-for="i in 3"
          :key="i"
          @click="setColumnCount(i)"
          class="btn--column"
        >
          <div :class="`column column--${i}`"></div>
          <span>{{ i }} column{{ i > 1 ? "s" : "" }}</span>
        </button>
      </div>
      <template slot="footer">
        <base-button danger @click="toggleColumnWidth">Cancel</base-button>
      </template>
    </modal>

    <modal v-if="showWidgetModal">
      <template slot="header">
        <h3>Select widget</h3>
      </template>
      <p>Choose a widget to add</p>
      <div class="flex space-even flex-wrap add-module">
        <button
          v-for="(mod, index) in modules"
          :key="index"
          @click="addWidget(mod)"
          class="btn--column"
        >
          <div>
            <icon :icon="getIcon(mod)" width="30" height="30" :fill="false" />
          </div>
          <span>{{ mod }}</span>
        </button>
      </div>
      <template slot="footer">
        <base-button danger @click="toggleAddWidget">Cancel</base-button>
      </template>
    </modal>

    <modal v-if="showConfigureWidget">
      <template slot="header">
        <h3>Configure {{ activeWidgetType | titleCase }} Widget</h3>
      </template>
      <div
        class="flex"
        v-for="prop in activeWidget.propsConfig"
        :key="prop.key"
      >
        <form-field
          full-width
          :label="prop.label | titleCase"
          :name="prop.key"
          type="text"
          :value="newProps[prop.key]"
          v-model="newProps[prop.key]"
          v-if="prop.type == 'text'"
          :helper-text="prop.helperText"
          v-validate="prop.validation"
          :error="errors.first(prop.key)"
        ></form-field>
        <form-field
          full-width
          :label="prop.label | titleCase"
          :name="prop.key"
          :value="newProps[prop.key]"
          v-model="newProps[prop.key]"
          v-else-if="prop.type == 'checkbox'"
          :helper-text="prop.helperText"
          v-validate="prop.validation"
          :error="errors.first(prop.key)"
        >
          <div v-for="(val, index) in prop.options" :key="index">
            <label :for="`checkbox_${index}`"
              ><input
                type="checkbox"
                :checked="newProps[prop.key].includes(val.value)"
                @change="updateContentType(prop.key, val.value)"
                :id="`checkbox_${index}`"
                :name="`${activeWidgetType}_${prop.key}`"
              />
              {{ val.name }}</label
            >
          </div>
        </form-field>

        <form-field
          full-width
          :label="prop.label | titleCase"
          :name="prop.key"
          :value="newProps[prop.key]"
          v-model="newProps[prop.key]"
          v-else-if="prop.type == 'component'"
          :helper-text="prop.helperText"
          v-validate="prop.validation"
          :error="errors.first(prop.key)"
        >
          <component :is="prop.componentName" v-model="newProps[prop.key]" />
        </form-field>
      </div>
      <template slot="footer">
        <base-button :primary="true" @click="saveProp">Save</base-button>
        <base-button danger @click="togglePreference">Cancel</base-button>
      </template>
    </modal>
  </div>
</template>

<script>
import draggable from 'vuedraggable';

import { BaseContainer } from '@/components/Containers';
import { mapState, mapGetters } from 'vuex';
import { adminModules } from '@/components/widgets';
import DashboardControls from '@/components/DashboardControls';
import UserHasPermission from '@/mixins/UserHasPermission';
import WidgetMixin from '@/mixins/dashboard';
import { trimLayout } from '@/components/widgets/helpers';

const SystemIcon = () => import('@/components/SystemIcon');

export default {
  name: 'DashboardAdminEdit',
  components: {
    BaseContainer,
    SystemIcon,
    draggable,
    DashboardControls,
  },
  mixins: [UserHasPermission, WidgetMixin],
  data() {
    return {
      modules: adminModules,
      loading: true,
    };
  },
  async mounted() {
    // this.hasClass();
    this.loading = false;
    this.$store
      .dispatch('widgets/getAdminUserDashboard', { isAdmin: true })
      .then(() => {
        this.headerLayout =
          this.$store.getters['widgets/adminHeaderWidgets'].compiled || [];
        this.mainLayout =
          this.$store.getters['widgets/adminMainWidgets'].compiled || [];
        this.footerLayout =
          this.$store.getters['widgets/adminFooterWidgets'].compiled || [];
      });
  },
  methods: {

    async toggleCustomize() {
      this.editMode = !this.editMode;

      if (!this.editMode) {
        // if we are cancelling the edit, just reload the current state and re-set the widgets
        this.loading = true;
        await this.$store.dispatch('widgets/getAdminUserDashboard', {
          isAdmin: true,
        });
        this.headerLayout =
          this.$store.getters['widgets/adminHeaderWidgets'].compiled || [];
        this.mainLayout =
          this.$store.getters['widgets/adminMainWidgets'].compiled || [];
        this.footerLayout =
          this.$store.getters['widgets/adminFooterWidgets'].compiled || [];
        this.loading = false;
      }

      if (!this.editMode) {
        // if we are cancelling, revert back to original state
        this.$store.dispatch('widgets/resetDashboard');
      }
    },

    // this needs to be slightly different from the main saveLayout method
    saveLayout() {
      const { headerLayout, mainLayout, footerLayout } = this;
      this.$store
        .dispatch('widgets/setUserDashboard', {
          layouts: {
            headerLayout,
            mainLayout,
            footerLayout,
          },
          admin: true,
        })
        .then((resp) => {
          // TODO: Should we reload?  Layout should be cleared from cache either way
          this.loading = true;
          this.$store.dispatch('widgets/reloadDashboard', true).then(() => {
            this.headerLayout = trimLayout(this.headerLayout);
            this.mainLayout = trimLayout(this.mainLayout);
            this.footerLayout = trimLayout(this.footerLayout);
            this.editMode = false;
            this.loading = false;
            this.$store.dispatch(
              'notifications/create',
              {
                body: 'The global layout was updated successfully',
                type: 'success',
              },
              { root: true },
            );
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
// TODO: Move to a scss file and share with dashboad
.p-dashboard {
  @media (min-width: 768px) {
    width: 95%;
  }
}
.dashboard {
  &--add-el {
    background-image: linear-gradient(
      135deg,
      lighten(#425563, 50%) 25%,
      transparent 25%,
      transparent 50%,
      lighten(#425563, 50%) 50%,
      lighten(#425563, 50%) 75%,
      transparent 75%,
      transparent 100%
    );
    background-repeat: repeat;
    background-size: 12.49px 12.49px;
    border: 3px dashed #425563;
    box-sizing: border-box;
    display: flex;
    margin: 0;
    padding: 3vh 0;
    place-content: center;

    &:last-of-type {
      // margin-bottom: 0;
    }
  }

  &--dynamic__row {
    .dashboard--add-el {
      margin: 0 0 2rem;
    }
  }

  &__overlay {
    &:before {
      background: #425563;
      color: white;
      content: "";
      display: block;
      height: 100%;
      left: 0;
      opacity: 0.5;
      position: absolute;
      top: 0;
      width: 100%;
      z-index: -1;
    }
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    left: 1rem;
    place-content: center;
    position: absolute;
    top: 0;
    width: calc(100% - 2rem);
    z-index: 2;

    &__controls {
      align-items: center;
      display: flex;
      justify-content: center;
      width: 100%;
    }
  }
}
.flip-list-move {
  transition: transform 0.5s;
  @media (prefers-reduced-motion: none) {
    transition: none;
  }
}
.ghost {
  opacity: 0.5;
}

.btn {
  &--column {
    background: none;
    border: 3px solid $colour-nhs-med-grey;
    border-radius: 20px;
    cursor: pointer;
    margin: 0 2.5% 1rem;
    padding: 20px;
    text-transform: capitalize;
    min-width: 28%;
    flex: 1 1 0;

    div {
      margin-bottom: 10px;
    }

    &:hover {
      border-color: $colour-nhs-core-blue;
    }
  }
}

.column {
  background: $colour-nhs-med-grey;

  height: 100px;
  margin: 0 auto 10px;
  position: relative;
  width: 100%;
  &--2 {
    &:before {
      width: 1px;
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      height: 100%;
      background: white;
      content: "";
    }
  }
  &--3 {
    &:before,
    &:after {
      width: 1px;
      position: absolute;
      top: 0;
      transform: translateX(-50%);
      height: 100%;
      background: white;
    }
    &:before {
      left: 33%;
      content: "";
    }
    &:after {
      width: 1px;
      position: absolute;
      top: 0;
      left: 66%;
      transform: translateX(-50%);
      height: 100%;
      background: white;
      content: "";
    }
  }
}

.dropzone {
  margin-bottom: 2rem;

  &__label {
    color: $colour-nhs-dark-grey;
    margin-bottom: 0.1rem;
  }

  &__container {
    border: 1px dotted $colour-nhs-dark-grey;
    min-height: 20vh;
    padding: 5px;
  }
}

.add-module {
  /deep/ .svg-icon {
    stroke: #425563;
  }
}

.mb-12 {
  margin-bottom: 3rem;
}
</style>
